module.exports = __webpack_public_path__ + "static/media/file.f4909c72.svg";